function c(message){console.log(message);}
document.addEventListener("DOMContentLoaded", function() {
    const configurator = {
        components: {
            option1Component: document.querySelectorAll("input.option1"),
            postProductsComponent: document.querySelector("#post-products"),
            // postProductComponent: document.querySelectorAll("#post-products input.radio-product"),
            postProductComponent: document.querySelectorAll("#post-products .product-card input.radio-product"),
            flangeProductLineComponent: document.querySelector(".flange-products"),
            flangeProductsComponent: document.querySelectorAll(".flange-products .product-card input.radio-product"),
            heigthComponent: document.querySelector("#cfg-height"),
            configuratorSizeComponent: document.querySelector("#configuratorSize"),
            basketTable: document.querySelector("#basket"),
            basketTableBody: document.querySelector("#basket tbody"),
            basketTableTotalPrice: document.querySelector("#basket tfoot .totalPrice"),
            heigthFirstOptionComponent: document.querySelectorAll("#cfg-height option[value='-1']"),
            postSelectComponent: document.querySelectorAll("input.post-selector"),
            productCardComponent: document.querySelectorAll(".product-card"),
            productCardRadioComponent: document.querySelectorAll(".product-card input.radio-product"),
            additionalProductsComponent: document.querySelectorAll(".additionalProducts"),
            purchasableComponent: document.querySelectorAll(".purchasable"),
            countboxComponent: document.querySelectorAll(".countbox"),
            productListOverlay: document.querySelector(".product-list-overlay"),
            postSelectorFlanged: document.getElementById('postSelectorFlanged'),
            addonProductComponent: document.querySelectorAll('.addon-product input.radio-product'),
            addToCart: document.getElementById('add-to-cart')
        },
        variables: {
            totalSize: 0,
            selectedOption1: null,
            selectedOption2: null,
            selectedProduct: null,
            selectedProductVariant: null,
            selectedProductQuantity: 0,
            selectedPostProduct: null,
            selectedPostProductVariant: null,
            isSelectedPostProductFlanged: false,
            selectedPostProductQuantity: 0,
            selectedAdditionalProducts: [],
            debugMode: true,
            basket: {
                items: [],
                total: 0
            },
            application:{
                properOptions : [
                    'Height',
                    'Color'
                ]
            }
        },
        function: {
            init: () =>{
                configurator.function.commonFunctions.onchange(configurator.components.option1Component, configurator.function.variantOnChange)
                configurator.function.commonFunctions.onchange(configurator.components.postSelectComponent, configurator.function.postSelectOnChange)
                configurator.function.commonFunctions.onchange(configurator.components.postProductComponent, configurator.function.postProductSelectOnChange)
                configurator.function.commonFunctions.onchange([configurator.components.heigthComponent], configurator.function.heigthOnChange)
                configurator.function.commonFunctions.onchange([configurator.components.configuratorSizeComponent], configurator.function.widthOnChange)
                configurator.function.commonFunctions.onchange(configurator.components.flangeProductsComponent, configurator.function.flangeProductChange)
                configurator.function.commonFunctions.onchange(configurator.components.countboxComponent, configurator.function.countboxChange)
                configurator.function.commonFunctions.onchange(configurator.components.addonProductComponent, configurator.function.addonProductChanged)
                configurator.function.commonFunctions.onclick(configurator.components.purchasableComponent, configurator.function.purchasableChange)
                // configurator.function.commonFunctions.onchange(configurator.components.productCardRadioComponent, configurator.function.productRadioOnChange)
                configurator.function.commonFunctions.onclick(configurator.components.productCardComponent, configurator.function.productOnClick)
                configurator.function.commonFunctions.onclick([configurator.components.addToCart], configurator.function.addToCart)
            },
            variantOnChange: (element) => {
                let itemId = element.getAttribute('data-item-id');
                let variantName = element.getAttribute('data-item-variant-name');
                let radioElement = element.closest('product-card').querySelector('.radio-product');
                console.log(element.closest('.variants'));
                element.closest('.product-list-overlay').querySelectorAll('.cfg-product-variant').forEach((elm) => {
                    elm.classList.remove('active');
                })
                window.cfgProduct.forEach(function(product){
                    if(itemId == product.id){
                        configurator.variables.selectedProduct = product;
                    }
                });
                element.closest('.cfg-product-variant').classList.add('active');
                
                configurator.function.setOption2Name(variantName);
                configurator.function.setHeigthBox(configurator.variables.selectedProduct, variantName);
                configurator.function.addAdditionalProducts(radioElement);

                configurator.function.productRadioOnChange(radioElement);
            },
            widthOnChange: (element) => {
                configurator.variables.totalSize = element.value;
                configurator.function.adjustBasket();
            },
            getProperProduct: (products) => {
                let availableVariant = availableProduct = null;
                let option1 = configurator.variables.selectedOption1;
                products.forEach((product)=>{product.variants.forEach((variant)=>{
                let variantHeigth = variant.option1.split("Zaunhöhe")[1].replace(/[:\s\)]+/g, '')

                    if(variantHeigth === option1 &&
                        variant.option2 === configurator.variables.selectedProductVariant.option2 &&
                        (product.title.toLowerCase().search('flange')>=0) === configurator.variables.isSelectedPostProductFlanged
                    ){
                        availableProduct = product;
                        availableVariant = variant;
                    }
                })});
                
                return {'product': availableProduct, 'variant': availableVariant};
            },
            countboxChange: (element) => {
                let product = JSON.parse(element.dataset.product);
                let index = element.dataset.index;
                let quantity = element.value;
                let availableProduct = configurator.function.getProperProduct(product);

                configurator.variables.selectedAdditionalProducts[index] = {
                    'product': availableProduct.product,
                    'variant': availableProduct.variant,
                    'quantity': quantity
                }
                console.log({
                    'product': availableProduct.product,
                    'variant': availableProduct.variant,
                    'quantity': quantity
                })
                configurator.function.adjustBasket();
            },
            addonProductChanged: (element) => {
                let index = element.getAttribute('data-list-index');
                if(element.checked == false){configurator.variables.selectedAdditionalProducts.splice(index); configurator.function.adjustBasket(); return;}
                let product = JSON.parse(element.dataset.product);
                let quantity = element.dataset.quantity;

                configurator.variables.selectedAdditionalProducts[index] = {
                    'product': product,
                    'variant': product.variants[0],
                    'quantity': quantity
                }
                
                configurator.function.adjustBasket();
            },
            getQuantity: (type, defaultQuantity) => {
                let quantity = defaultQuantity;
                if('fence' === type){
                    quantity = configurator.variables.selectedProductQuantity;
                }else if('post' === type){
                    quantity = configurator.variables.selectedPostProductQuantity;
                }else if('post-heigth-quantity' === type){
                    quantity = parseFloat(configurator.variables.selectedPostProductVariant.option1.replace('cm', '')) * configurator.variables.selectedPostProductQuantity;
                }else if('none' === type){
                    quantity = 1;
                }

                return quantity;
            },
            postProductSelectOnChange: (element) => {
                productId = JSON.parse(element.getAttribute('data-product-id'));
                window.cfgPostProduct.forEach((product) => {
                    if(product.id == productId){
                        let searchedOption1 = configurator.variables.selectedOption1;
                        product.variants.forEach(variant => {
                            let variantHeigth = variant.option1.split("Zaunhöhe")[1].replace(/[:\s\)]+/g, '')
                            if(variantHeigth === searchedOption1 && variant.option2 === configurator.variables.selectedOption2){
                                configurator.variables.selectedPostProduct = product;
                                configurator.variables.selectedPostProductVariant = variant;
                                configurator.variables.isSelectedPostProductFlanged = product.title.toLowerCase().search('flange') >= 0;
                                configurator.function.adjustFlangeProducts(product);  
                                return;
                            }
                        });
                    }
                });
              
                configurator.function.adjustBasket();
                configurator.function.productRadioOnChange(element);
            },
            addAdditionalProducts: () => {
                Object.keys(window.additionalProduct).forEach(key => {
                    let element = window.additionalProduct[key];
                    let quantity = element.quantity;
                    if(element.quantityEqualTo !== ''){
                        quantity = configurator.function.getQuantity(element.quantityEqualTo, 1) * (parseFloat(element.multiplier) > 0.001 ? parseFloat(element.multiplier): 1);
                    }
                    configurator.function.addBasket(element.product, element.variant, quantity)
                });
            },
            flangeProductChange: (element) => {
                let product = JSON.parse(element.getAttribute('data-product'));
                let variant = JSON.parse(element.getAttribute('data-first-variant'));
                let index = JSON.parse(element.getAttribute('data-list-index'));
                let quantity = configurator.function.getQuantity(element.getAttribute('data-quantity-equal-with'));
                
                configurator.variables.selectedAdditionalProducts[index] = {
                    'product': product,
                    'variant': variant,
                    'quantity': quantity
                }
                configurator.function.adjustBasket();
                configurator.function.productRadioOnChange(element);
            },
            purchasableChange: (element) => {
                let dataElement = element.querySelector('.radio-product');
                let product = JSON.parse(dataElement.getAttribute('data-product'));
                let variant = JSON.parse(dataElement.getAttribute('data-first-variant'));
                let equalQuantity = dataElement.getAttribute('data-quantity-equal-with');
                let index = dataElement.getAttribute('data-list-index');
                configurator.function.adjustQuantity();

                let quantity = configurator.function.getQuantity(equalQuantity);
                
                configurator.variables.selectedAdditionalProducts[index] = {
                    'product': product,
                    'variant': variant,
                    'quantity': quantity
                }

                configurator.function.adjustBasket();
                configurator.function.productRadioOnChange(dataElement);
            },
            disabledFlangedProducts: () => {
                configurator.components.postSelectorFlanged.disabled = true;
            },
            heigthOnChange: (element) => {
                let selectedOption = element.options[element.selectedIndex]
                let dontShowIfEqual = configurator.components.productListOverlay.dataset.dontshowifsizeequal.split(',');

                configurator.variables.selectedOption1 = selectedOption.dataset.option1;
                configurator.variables.selectedProduct = JSON.parse(selectedOption.dataset.product);
                configurator.variables.selectedProductVariant = JSON.parse(selectedOption.dataset.variant);
                
                if(dontShowIfEqual.includes(configurator.variables.selectedOption1)){
                    configurator.components.postSelectorFlanged.disabled = true;
                }else{
                    configurator.components.postSelectorFlanged.disabled = false;
                }
                
                configurator.function.adjustBasket();
            },
            productOnClick: (element) => {
                let selectedProductElement = element.querySelector('input.radio-product');
                if(selectedProductElement.dataset.addon == 'true' && selectedProductElement.checked === true){
                    selectedProductElement.checked = false;
                }else{
                    selectedProductElement.checked = true;
                }
                selectedProductElement.dispatchEvent(new Event('change'));
                configurator.function.productRadioOnChange(selectedProductElement);
            },
            productRadioOnChange: (element) => {
                let productListIndex = element.getAttribute('data-list-index');
                document.querySelectorAll('.product-list-'+productListIndex+' .product-card').forEach(function(element){
                    element.classList.remove('selected');
                });
                if(element.checked == true){
                    element.closest('.product-card').classList.add('selected');
                }
            },
            adjustFlangeProducts: (product) => {
                configurator.components.flangeProductsComponent.forEach((flangeProduct)=>{
                    (JSON.parse(flangeProduct.dataset.product)).tags.forEach((tag) => {
                        if(product.tags.includes(tag) == true){
                            flangeProduct.closest('.columns').style.display = 'block';
                        }else{
                            flangeProduct.closest('.columns').style.display = 'none'
                        }
                    });
                });
            },
            postSelectOnChange: (element) => {
                let value = element.getAttribute('value');
                configurator.components.postProductsComponent.querySelectorAll('#post-products .post-product').forEach(function(element){
                    element.style.display = 'none';
                })
                configurator.components.flangeProductLineComponent.style.display = value == "post-flanged" ? 'block': 'none';
                configurator.components.postProductsComponent.querySelector('.'+value).style.display = 'flex';

                configurator.components.addonProductComponent.forEach(function(element){
                    if(element.dataset.tags.includes('PRODUCT_TYPE_CEMENT')){
                        element.closest(".product-list").style.display = value != "post-flanged" ? 'block': 'none';
                    }
                })
            },
            setHeigthBox: (product, variantName) => {
                let firtsOption = configurator.components.heigthComponent.querySelector('option[value="-1"]');
                configurator.components.heigthComponent.innerHTML = '';
                configurator.components.heigthComponent.append(firtsOption);
                product.variants.forEach(function(variant){
                    if(variant.option2 !== variantName){
                        return;
                    }
                    var option = document.createElement('option');
                    option.text = variant.option1;
                    option.value = variant.id;
                    option.dataset.option1 = variant.option1;
                    option.dataset.product = JSON.stringify(product);
                    option.dataset.variant = JSON.stringify(variant);
                    configurator.components.heigthComponent.append(option);
                });
            },
            setOption2Name: (variantName) => {
                configurator.variables.selectedOption2 = variantName;
            },
            commonFunctions:{
                onclick: function(components, func){
                    [...components].forEach(function(component){
                        component.onclick = () => {
                            func(component);
                        }
                    }); 
                },
                onchange: function(components, func){
                    Array.from(components).forEach(function(component){
                        component.onchange = () => {
                            func(component);
                        }
                    }); 
                }
            },
            findProduct: (productId, variantId) => {
                
            },
            getBasketObject: (product, variant, count) =>{
                return {product: product, variant: variant, count: count}
            },
            addBasket: (product, variant, count) => {
                if(!variant){return;}
                if(!Array.isArray(configurator.variables.basket.items)){
                    configurator.variables.basket.items = [];
                    configurator.variables.basket.total = 0;
                }
                count = Math.round(count);
                configurator.variables.basket.items.push(configurator.function.getBasketObject(product, variant, count))
                configurator.variables.basket.total += variant.price * count;
            },
            adjustQuantity: () =>{
                configurator.variables.selectedProductQuantity = Math.round(configurator.variables.totalSize/2.5);
                configurator.variables.selectedPostProductQuantity = configurator.variables.selectedProductQuantity;
            },
            purchasableProductsAddtoBasket: () => {
                configurator.variables.selectedAdditionalProducts.forEach((data) => {
                    configurator.function.addBasket(data.product, data.variant, data.quantity);
                });
            },
            adjustBasket: () =>{
                try{
                    configurator.function.resetBasket();
                    configurator.function.adjustQuantity();
                    configurator.function.addBasket(configurator.variables.selectedProduct, configurator.variables.selectedProductVariant, configurator.variables.selectedProductQuantity);
                    configurator.function.addBasket(configurator.variables.selectedPostProduct, configurator.variables.selectedPostProductVariant, configurator.variables.selectedProductQuantity);
                    configurator.function.addAdditionalProducts()
                    configurator.function.purchasableProductsAddtoBasket()
    
                    configurator.function.renderBasket();
                }catch(err){
                    console.log(err);
                }
            },
            resetBasket: () =>{
                configurator.variables.basket = [];
            },
            addToCart: async function(element){
                element.classList.add('loading');
                await CartJS.clear();
                let formData = {
                    'items': []
                };
                configurator.variables.basket.items.forEach((item) =>{
                    formData.items.push({'id': item.variant.id, 'quantity': item.count})
                });

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                  })
                  .then(response => {
                    window.location.href = "/cart";
                  })
                  .catch((error) => {
                    element.classList.remove('loading');
                    console.error('Error:', error);
                });

            },
            resetBasketTable: () =>{
                configurator.components.basketTableBody.innerHTML = '';
            },
            renderBasket: () =>{
                configurator.function.resetBasketTable();
                configurator.variables.basket.items.forEach((item) =>{
                    let row = document.createElement('tr');
                    let idCell = (document.createElement('td'));
                    let titleCell = (document.createElement('td'));
                    let priceSingle = (document.createElement('td'));
                    let count = (document.createElement('td'));
                    let countInput = document.createElement('input');
                    let priceTotal = (document.createElement('td'));

                    idCell.innerText = item.product.id;
                    titleCell.innerText = item.product.title;
                    priceSingle.innerText = Shopify.formatMoney(item.variant.price, '€{{amount}}');
                    priceTotal.innerText = Shopify.formatMoney(item.variant.price * item.count, '€{{amount}}');
                    countInput.value = item.count;
                    countInput.type = 'text';
                    count.append(countInput);

                    row.append(idCell);
                    row.append(titleCell);
                    row.append(priceSingle);
                    row.append(count);
                    row.append(priceTotal);
                    configurator.components.basketTableBody.append(row);
                });
                configurator.components.basketTableTotalPrice.innerText = Shopify.formatMoney(configurator.variables.basket.total, '€{{amount}}');
                configurator.components.addToCart.disabled = false;
            },
            log: (message) => {
                if(!configurator.variables.debugMode){return;}
                console.log(message);
            }
        },
        mount: () => {
            configurator.function.init();
        }
    }

    addEventListener("load", configurator.mount);
});
